module.exports = __webpack_public_path__ + "img/Excel-icon.13d0e5bf.jpg";